module.exports = __webpack_public_path__ + "img/svg/verify-identity-divider.057fd611e9fa151f39e6bb14f58100bc.svg";